import ErrorMessage from 'utils/ErrorMessage'
import authRequest from 'utils/authRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'

export const SET_ADMIN_DASHBOARD_METRICS = 'admin/SET_ADMIN_DASHBOARD_METRICS'
export const SET_ADMIN_DASHBOARD_LOADING = 'admin/SET_ADMIN_DASHBOARD_LOADING'
export const SET_DASHBOARD_USERS = 'admin/SET_DASHBOARD_USERS'
export const SET_DASHBOARD_USERS_LOADING = 'admin/SET_DASHBOARD_USERS_LOADING'

export const setAdminDashboardMetrics = data => {
  return {
    type: SET_ADMIN_DASHBOARD_METRICS,
    data,
  }
}

export const setAdminDashboardLoading = loading => {
  return {
    type: SET_ADMIN_DASHBOARD_LOADING,
    data: loading,
  }
}

export const setDashboardUsers = data => {
  return {
    type: SET_DASHBOARD_USERS,
    data,
  }
}

export const setDashboardUsersLoading = loading => {
  return {
    type: SET_DASHBOARD_USERS_LOADING,
    data: loading,
  }
}

export const getAdminDashboardMetrics = () => async (dispatch, getState) => {
  try {
    dispatch(setAdminDashboardLoading(true))
    
    // Fetch dashboard metrics from the new API endpoint
    const response = await authRequest.get('/dashboard/metrics?timeRange=15min')
    
    const metrics = {
      activeCorporates: response?.data?.data?.Corporate?.active || 0,
      activeInstitutes: response?.data?.data?.Institute?.active || 0,
      totalCorporates: response?.data?.data?.Corporate?.total || 0,
      totalInstitutes: response?.data?.data?.Institute?.total || 0,
      totalActiveStudents: response?.data?.data?.Student?.total || 0,
      activeStudents: response?.data?.data?.Student?.active || 0,
      totalAdmins: response?.data?.data?.Admin?.total || 0,
      activeAdmins: response?.data?.data?.Admin?.active || 0,
    }

    dispatch(setAdminDashboardMetrics(metrics))
    return metrics
  } catch (error) {
    dispatch(setAdminDashboardLoading(false))
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch dashboard metrics')
    return error
  }
}

export const getDashboardUsers = ({ page = 0, limit = 10, search = '', role = '', status = '' } = {}) => async (dispatch, getState) => {
  try {
    dispatch(setDashboardUsersLoading(true))
    
    // Build query parameters
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    })
    
    if (search) params.append('search', search)
    if (role) params.append('role', role)
    if (status) params.append('status', status)
    
    const response = await authRequest.get(`/dashboard/users?${params.toString()}`)
    
    // Handle the response structure based on your API format
    const usersData = {
      list: response?.data?.data?.list || response?.data?.data || [],
      totalCount: response?.data?.data?.totalCount || response?.data?.data?.total || 0,
      currentPage: response?.data?.data?.currentPage || page,
      totalPages: response?.data?.data?.totalPages || 0,
    }

    dispatch(setDashboardUsers(usersData))
    return usersData
  } catch (error) {
    dispatch(setDashboardUsersLoading(false))
    ErrorMessage(error?.response?.data?.message || 'Failed to fetch dashboard users')
    return error
  }
}
